import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";

export const CookieBanner = () => {
  const { config, t } = useSite();
  const [accepted, setAccepted] = useState(() => localStorage.getItem("jl_cookies") === "1");
  if (accepted || !config?.privacy?.cookie_banner) return null;
  const accept = () => { localStorage.setItem("jl_cookies", "1"); setAccepted(true); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[60] bg-white border border-neutral-200 shadow-xl p-5" data-testid="cookie-banner">
      <p className="text-sm text-neutral-700 leading-relaxed">{t(config.privacy.cookie_text)}</p>
      <div className="flex items-center gap-4 mt-4">
        <Button onClick={accept} data-testid="cookie-accept-btn" className="bg-[#d00000] hover:bg-[#a30000] text-white rounded-none">{t("Accept")}</Button>
        <Link to="/privacy" className="text-sm text-neutral-500 underline hover:text-[#d00000]" data-testid="cookie-privacy-link">{t("Privacy Policy")}</Link>
      </div>
    </div>
  );
};
